import { Box, HStack, Image, Link, StackProps } from "@chakra-ui/react"
import { Link as ReactRouterLink } from "react-router-dom"
import { HomeRegistrationFragment } from "../../../api/generated"
import ChakraTooltip from "../../../components/ChakraTooltip"
import { getRegistrationPathLink } from "../../utils"

function NestedPaths({
  nestedRegistrations,
  ...stackProps
}: {
  nestedRegistrations?: HomeRegistrationFragment[]
} & StackProps) {
  return nestedRegistrations?.length ? (
    <HStack
      maxW="100%"
      overflow="auto"
      bg="whiteAlpha.400"
      borderRadius="md"
      p={1}
      spacing={1}
      {...stackProps}
    >
      {nestedRegistrations.map((registration) => (
        <ChakraTooltip
          key={registration.id}
          title={registration.resource?.name!}
          fitContent
          popover={{
            openDelay: 300
          }}
        >
          <Link
            as={ReactRouterLink}
            to={getRegistrationPathLink(registration)}
            cursor="pointer"
            lineHeight={0}
          >
            <Image
              src={registration.resource?.cover_image}
              maxW="3em"
              borderRadius="md"
              alignSelf="flex-start"
              fallback={
                <Box w="3em" h="2.25em" bg="gray.200" borderRadius="md" />
              }
              _hover={{
                opacity: ".8"
              }}
            />
          </Link>
        </ChakraTooltip>
      ))}
    </HStack>
  ) : null
}

export default NestedPaths
